export default "__VITE_ASSET__oRvQUNCU__"